import * as React from 'react';
export const arkeaSvg = React.forwardRef(function arkeaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#ED1C23',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12.417 0H0v32-3.88c.774-.174 1.537-.353 2.278-.587 5.497-1.735 9.812-5.136 13.305-9.64.442-.57.835-.766 1.55-.702 6 .534 10.973 2.938 14.867 7.366V0v18.996a25.435 25.435 0 0 0-.91-.72c-3.719-2.762-7.915-4.317-12.494-4.878a30.968 30.968 0 0 0-1.273-.121 32.584 32.584 0 0 1-1.217-.115c-.192-.023-.434-.132-.543-.282a17.55 17.55 0 0 1-3.184-8.332c-.171-1.52-.136-3.035.038-4.548ZM0 24.025c4.98-1.296 8.889-4.2 12.06-8.227.266-.336.263-.547.026-.9C9.203 10.597 8.017 5.84 8.332.69c.01-.175.024-.359.039-.538L8.383 0H0v24.025Z',
      fill: '#fff',
    }),
  );
});
arkeaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var arkea = {
  category: 'brand',
  colorable: false,
  name: 'arkea',
  svg: arkeaSvg,
};
